import uniqueId from 'lodash/uniqueId';
import Application from '../application';
import SVG from 'svg.js';
import { TYPE, SEATSTATUS } from '@/constants';
import { SelectableRequirements } from '../mixins/SelectableMixin';
import { CategoryRequirements } from '../mixins/CategoryMixin';
import { Block } from './block';
import { Row } from './row';
import { TableSeat } from './tables/tableSeat';
import { Seat } from './seat';
import { Table } from './tables/table';

export interface ModelParams {
  uuid?: string;
  sid?: string;
  attributes?: any;
  subtype?: (typeof TYPE)[keyof typeof TYPE];
  rows?: any[];
  block?: Block;
  type?: (typeof TYPE)[keyof typeof TYPE];
  seats?: Array<Seat | TableSeat>;
  row?: Row;
  table?: Table;
}

export default class Model implements SelectableRequirements, CategoryRequirements {
  uuid: string;
  declare sid?: string;
  app: Application;
  svg: SVG.Doc;
  canvas: SVG.G;
  attributes: Record<string, any> & { status: (typeof SEATSTATUS)[keyof typeof SEATSTATUS] };
  isSelected: boolean;
  declare view: SVG.G;
  declare shape: SVG.Shape;

  constructor(params: ModelParams = {}) {
    const { uuid, sid, attributes = {} } = params;
    this.uuid = uuid || this.getUniqueId();
    this.app = Application.instance;
    this.svg = this.app.svg;
    this.canvas = this.app.canvas;
    if (sid) {
      try {
        this.sid = sid;
      } catch (e) {
        //nothing
      }
    }
    this.attributes = attributes;
    this.isSelected = false;
  }

  get type(): (typeof TYPE)[keyof typeof TYPE] {
    throw new Error('Method not implemented.');
  }

  get seatsCount() {
    return 0;
  }

  getUniqueId() {
    const id = uniqueId(`${this.type}_`);
    const milliseconds = new Date().getTime();
    const uid = id + milliseconds;
    return uid;
  }

  static getUniqueIdStatic(type: string) {
    const id = uniqueId(`${type}_`);
    const milliseconds = new Date().getTime();
    const uid = id + milliseconds;
    return uid;
  }

  setAttribute(name: string, value: any) {
    if (this.attributes[name] === value) return;
    this.attributes[name] = value;
  }

  setStyle(name: string, value: any) {
    if (this.attributes.styles[name] === value) return;
    this.attributes.styles[name] = value;
  }

  show() {
    this.view!.attr('visibility', 'visible');
  }

  hide() {
    this.view!.attr('visibility', 'hidden');
  }

  isHidden() {
    return this.view!.attr('visibility') === 'hidden';
  }

  toFront() {
    this.view!.front();
  }

  toBack() {
    this.view!.back();
  }

  rbox(parent = this.app.svg) {
    return this.view!.rbox(parent);
  }

  shapeBox() {
    return this.shape!.rbox();
  }

  untransform() {
    this.view!.untransform();
  }

  static filteredJSON(json: object) {
    return JSON.parse(JSON.stringify(json));
  }

  hideLabel() {}
  showLabel() {}
  moveShapes(x: number, y: number) {}
}
